<template>
    <div v-if="plan" class="app-membership-offer">
        <p class="_title">NannyGranny Membership</p>
        <p class="_price">${{ price }}</p>
        <p class="_period">for {{ plan.invoice_period }} months</p>
        <p class="_then">Then $6.70/month &middot; Cancel anytime</p>
        <p class="_tagline">Everything you need to find and connect<br>with your NannyGranny.</p>
        <ul class="_features">
            <li>Contact NannyGrannies directly</li>
            <li>Shortlist your favourites</li>
            <li>Post what you're looking for</li>
            <li>Keep searching until you find the right fit</li>
            <li>No agency or placement fees</li>
        </ul>
        <template v-if="!hideButton">
            <v-btn v-if="to"
                   :to="to"
                   class="ma-0 v-btn--default elevation-0 _btn">
                Get full access &mdash; ${{ price }}
            </v-btn>
            <v-btn v-else
                   :loading="loading"
                   class="ma-0 v-btn--default elevation-0 _btn"
                   @click="$emit('select', plan)">
                Get full access &mdash; ${{ price }}
            </v-btn>
        </template>
    </div>
</template>

<script>
  import { DEFAULT_SIGNUP_OPT } from '../../config/constants'

  // NannyGranny Membership offer card (User Flow 4). Price comes from the backend plan.
  // Pass `to` for a link CTA, or listen to `select` for a click handler.
  export default {
    name: 'app-membership-offer',

    props: {
      to: String,
      loading: Boolean,
      hideButton: Boolean
    },

    computed: {
      plan () {
        return this.$store.getters['subscription/plans'].find(item => item.id === DEFAULT_SIGNUP_OPT[0])
      },
      price () {
        return Math.round(this.plan.price)
      }
    }
  }
</script>

<style lang="stylus" scoped>
    .app-membership-offer
        max-width 460px
        margin 0 auto
        background #fff
        border 2px solid #039E8B
        border-radius 15px
        padding 28px 24px 24px
        text-align center
        p
            margin 0
        ._title
            font-size 16px
            font-weight bold
            letter-spacing 1px
            text-transform uppercase
            margin-bottom 10px
        ._price
            font-size 44px
            font-weight bold
            line-height 1.1
            color #039E8B
        ._period
            font-size 16px
        ._then
            font-size 13px
            color var(--charcoal)
            margin-top 4px
        ._tagline
            font-size 16px
            font-weight bold
            margin-top 20px
        ._features
            list-style none
            text-align left
            display inline-block
            margin 14px 0 22px
            padding 0
            li
                position relative
                padding-left 26px
                margin-bottom 6px
                font-size 15px
                &:before
                    content '\2713'
                    position absolute
                    left 0
                    color #039E8B
                    font-weight bold
        ._btn
            width 100%
            height auto !important
            padding 12px 0 !important
            background #039E8B !important
            color #fff !important
            font-weight bold
    @media (max-width: 480px)
        .app-membership-offer
            padding 22px 16px 18px
            ._price
                font-size 38px
</style>



// WEBPACK FOOTER //
// src/components/app-membership/app-membership-offer.vue